import * as sitemap from './sitemap';
import * as sitemapFile from './sitemap-file';
import * as robots from './robots-txt';
const {
  pattern: sitemapPattern,
  handler: sitemapHandler
} = sitemap;
const {
  pattern: sitemapFilePattern,
  handler: sitemapFileHandler
} = sitemapFile;
const {
  pattern: robotsTxtPattern,
  handler: robotsTxtHandler
} = robots;
const config = new Map();
config.set(sitemapPattern, sitemapHandler);
config.set(sitemapFilePattern, sitemapFileHandler);
config.set(robotsTxtPattern, robotsTxtHandler);
export default config;
//# sourceMappingURL=index.js.map